import { io, Socket } from 'socket.io-client';
import { DeviceConfigService } from '../services/deviceConfigService';

const envSocketUrl = process.env.REACT_APP_SOCKET_URL || '';
const socketURL = envSocketUrl ? (() => {
  const url = envSocketUrl.split("://");
  return `ws${url[0] === "https" ? "s" : ""}://${url[1]}`;
})() : 'ws://localhost:8080';

const IS_ON_PREM = process.env.REACT_APP_DEPLOYMENT_MODE === 'on-prem';

// Send a ping every 25 minutes — safely under the typical 30-min idle timeout
// on most routers/firewalls on on-prem networks.
const HEARTBEAT_INTERVAL_MS = 30 * 60 * 1000;

export const createSocket = (): Socket => {
  const tokenData = DeviceConfigService.getToken();
  const token = tokenData?.token;

  if (!token) {
    console.error('No auth token found. Device may not be configured.');
  }

  const socket = io(socketURL, {
    transports: ['websocket'],
    upgrade: false,
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
    auth: { token },
    query: { source: 'react' },
  });

  let heartbeatTimer: ReturnType<typeof setInterval> | null = null;

  const startHeartbeat = () => {
    if (!IS_ON_PREM) return;
    stopHeartbeat();
    heartbeatTimer = setInterval(() => {
      if (!socket.connected) return;
      console.log('[socket] heartbeat — reconnecting to refresh data...');
      socket.disconnect();
      socket.connect();
    }, HEARTBEAT_INTERVAL_MS);
  };

  const stopHeartbeat = () => {
    if (heartbeatTimer !== null) {
      clearInterval(heartbeatTimer);
      heartbeatTimer = null;
    }
  };

  socket.on('connect', () => {
    console.log('[socket] connected — starting heartbeat');
    startHeartbeat();
  });

  socket.on('disconnect', (reason) => {
    console.warn('[socket] disconnected:', reason);
    stopHeartbeat();
  });

  return socket;
};